export default __webpack_public_path__ + "static/intellij-idea-ae22b74b14645c50af3e7cc8cc358bf6.svg";